export default __webpack_public_path__ + "static/media/head-beige.973838fa.png";